import React, { createContext, useContext, useMemo, useState } from 'react';
import type { ShellApplicationClassificationFilter } from './application-classification';

interface ApplicationClassificationContextValue {
  readonly selectedClassification: ShellApplicationClassificationFilter;
  setSelectedClassification: (classification: ShellApplicationClassificationFilter) => void;
}

const ApplicationClassificationContext = createContext<ApplicationClassificationContextValue | null>(null);

export function ApplicationClassificationProvider({ children }: { children: React.ReactNode }) {
  const [selectedClassification, setSelectedClassification] =
    useState<ShellApplicationClassificationFilter>('ALL');

  const value = useMemo<ApplicationClassificationContextValue>(
    () => ({
      selectedClassification,
      setSelectedClassification,
    }),
    [selectedClassification],
  );

  return (
    <ApplicationClassificationContext.Provider value={value}>
      {children}
    </ApplicationClassificationContext.Provider>
  );
}

export function useApplicationClassificationFilter() {
  const context = useContext(ApplicationClassificationContext);
  if (!context) {
    throw new Error('useApplicationClassificationFilter must be used inside <ApplicationClassificationProvider>');
  }
  return context;
}
